module.exports = __webpack_public_path__ + "img/app-item-error.8466fac1.svg";